const PT_BR = {
    COUNTRY_CODE: 'BR',
    ID: 'pt-br',
    NUMBER_FORMAT: {
        CURRENCY_DESCRIPTION: 'Real',
        CURRENCY_SYMBOL: 'R$',
        DECIMAL_SEPARATOR: ',',
        GROUP_SEPARATOR: '.',
    },
};
export { PT_BR, };
//# sourceMappingURL=pt-br.js.map